module.exports = __webpack_public_path__ + "media/3-1.c5c8ed91.wav";